import { useEffect } from 'react';
import { useState } from 'react';
import { useGetNoteLazyQuery } from '@lon/mathnation-suit/requests';
import { syncLocalStorage } from '@lon/mathnation-suit/utils';

interface HighlightData {
  text: string;
  color: string;
}

const useGetHighlights = (iframeId: string) => {
  const [getHighlights] = useGetNoteLazyQuery();

  const [highlights, setHighlights] = useState<HighlightData[] | null>(null);

  useEffect(() => {
    const fetchHighlights = async (iframeId: string) => {
      if (!iframeId) return;
      try {
        const response = await getHighlights({
          variables: { id: iframeId },
          fetchPolicy: 'no-cache',
        });

        if (response?.data?.note?.item?.data) {
          const highlights = JSON.parse(response.data.note.item.data);
          setHighlights(highlights);
          syncLocalStorage(iframeId, highlights);
        }
      } catch (error) {
        console.error(`Failed to get highlights: ${error}`);
      }
    };

    fetchHighlights(iframeId);
  }, [iframeId]);

  return highlights || null;
};

export default useGetHighlights;
